module.exports = __webpack_public_path__ + "img/20201220_1.5292014e.jpg";